import { NOTICE_PRESETS } from '@beta-assur/shared';
import { useId, useState } from 'react';
import { useI18n } from '../lib/i18n';
import { Input, Select } from './ui/input';

// Délai de préavis (BA-079) : 1, 2 ou 3 mois, ou un nombre de jours libre. `none` propose en
// plus une valeur vide (pas de rappel, ou réglage hérité du niveau supérieur).

const CUSTOM = 'custom';
const NONE = 'none';

export function NoticeField({
  label,
  value,
  onChange,
  none,
  hint,
}: {
  label: string;
  value: number | null;
  onChange: (days: number | null) => void;
  /** Libellé du choix vide ; absent, un délai est obligatoire. */
  none?: string;
  hint?: string;
}) {
  const t = useI18n().t;
  const id = useId();
  const preset =
    value === null
      ? NONE
      : (NOTICE_PRESETS as readonly number[]).includes(value)
        ? String(value)
        : CUSTOM;
  const [custom, setCustom] = useState(preset === CUSTOM);
  const choice = custom ? CUSTOM : preset;
  return (
    <div className="flex flex-col gap-1">
      <label htmlFor={id} className="text-sm font-medium">
        {label}
      </label>
      <div className="flex gap-2">
        <Select
          id={id}
          value={choice}
          onChange={(e) => {
            const next = e.target.value;
            setCustom(next === CUSTOM);
            if (next === NONE) onChange(null);
            else if (next !== CUSTOM) onChange(Number(next));
            else if (value === null) onChange(45);
          }}
        >
          {none ? <option value={NONE}>{none}</option> : null}
          {NOTICE_PRESETS.map((days) => (
            <option key={days} value={days}>
              {t.notice.presets[days]}
            </option>
          ))}
          <option value={CUSTOM}>{t.notice.custom}</option>
        </Select>
        {choice === CUSTOM ? (
          <Input
            type="number"
            min={1}
            max={365}
            className="w-28"
            aria-label={`${label} (${t.notice.days})`}
            value={value ?? ''}
            onChange={(e) => onChange(e.target.value === '' ? null : Number(e.target.value))}
          />
        ) : null}
      </div>
      {hint ? <p className="text-xs text-muted-foreground">{hint}</p> : null}
    </div>
  );
}
